const flattenTree = (nodes = []) =>
  nodes.flatMap((node) => [node, ...flattenTree(node.children)]);

export const exportAnalyticalLayersToCSV = (data, filters, toast, texts) => {
  if (!data?.treeData?.length) {
    toast({
      title: texts?.reports?.noDataToExport || "لا توجد بيانات للتصدير",
      status: "warning",
      duration: 3000,
    });
    return;
  }

  let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
  csvContent += [texts?.reports?.account || "الحساب", ...data.headers].join(",");
  csvContent += "\r\n";

  flattenTree(data.treeData).forEach((row) => {
    const line = [row.label, ...row.values].map((value) => `"${value ?? ""}"`);
    csvContent += `${line.join(",")}\r\n`;
  });

  const link = document.createElement("a");
  link.href = encodeURI(csvContent);
  link.download = `${texts?.reports?.analyticalLayers || "Analytical_Layers"}_${filters.date}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportAnalyticalLayersToPDF = (data, filters, toast, texts) => {
  if (!data?.treeData?.length) {
    toast({
      title: texts?.reports?.noDataToExport || "لا توجد بيانات للتصدير",
      status: "warning",
      duration: 3000,
    });
    return;
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    toast({
      title: texts?.reports?.printError || "خطأ في الطباعة",
      status: "error",
      duration: 5000,
    });
    return;
  }

  const rows = flattenTree(data.treeData)
    .map(
      (row) => `<tr><td>${row.label}</td>${row.values
        .map((value) => `<td>${value ?? ""}</td>`)
        .join("")}</tr>`
    )
    .join("");

  printWindow.document.write(`<!DOCTYPE html><html dir="rtl"><head><meta charset="UTF-8" />
    <title>${texts?.reports?.analyticalLayers || "Analytical Layers"}</title>
    <style>body{font-family:Arial,sans-serif}table{width:100%;border-collapse:collapse}
    th,td{border:1px solid #ddd;padding:8px;text-align:right}th{background:#2c5aa0;color:#fff}</style>
    </head><body><h2>${texts?.reports?.analyticalLayers || "Analytical Layers"}</h2>
    <p>${filters.date}</p><table><thead><tr><th>${texts?.reports?.account || "الحساب"}</th>
    ${data.headers.map((header) => `<th>${header}</th>`).join("")}</tr></thead><tbody>${rows}</tbody></table>
    <script>window.onload=function(){setTimeout(()=>window.print(),500);}</script></body></html>`);
  printWindow.document.close();
};
